<script>
  import {cn} from "../../utils.js";
  import Day from "./bits/calendar-day.svelte";
  import * as money_util from "../../utils/MoneyUtil.js";
  import {progress} from "../../data/progress/feature.progress.svelte.js";
  //import { CalendarPrimitive } from "./calendar-day-primitive.svelte";
  import * as HoverCard from "../ui/hover-card/index.js";
  import ButtonCalendarInfo from "../button/button-calendar-info.svelte";
  import {widgets} from "../../data/widgets/feature.widgets.svelte.js";
  import {booking} from "../../data/booking/feature.booking.svelte.js";
  import {ENTRY_DURATION_DAY, ENTRY_DURATION_EVENING} from "../../AppConstants.js";

  () => typeof HoverCard

  let {
        ref                = $bindable(null),
        class: className,
        bCalendarHasPrices = true,
        date,
        oCalendarDayConfig,
        selected_value,
        ...restProps
      } = $props();

  // Als je zoekt op 'class CalendarCellState' dan zie je hoe de data-attributen en daardoor indirect onderstaande classes op de dagen komen
  // Voorbeeld: isOutsideMonth = $derived.by(() => !isSameMonth(this.date.current, this.month.current));
  //  cellDate = $derived.by(() => toDate(this.date.current));
  //  isDisabled = $derived.by(() => this.root.isDateDisabled(this.date.current));
  //  isUnavailable = $derived.by(() => this.root.isDateUnavailableProp.current(this.date.current));

  let oDateConfig = $state({
    bIsEnabled: false,
    sCustomClass: ''
  });

  if ( typeof progress.aCalendarDates[date.year + '-' + date.month + '-' + date.day] !== "undefined" )
  {
    oDateConfig = progress.aCalendarDates[date.year + '-' + date.month + '-' + date.day];
  }

  //console.log('debug temp hier', date, date.year + '-' + date.month + '-' + date.day, $state.snapshot(oDateConfig));

  // oCalendarDayConfig komt uit getCalendarConfigForDate
  let bIsEnabled = $state(false);
// console.log('snel testje', bCalendarHasPrices, oCalendarDayConfig);
  // let op, dit geven we ook al in calendar.svelte door via data-disabled
  if ( oCalendarDayConfig && oCalendarDayConfig.bIsEnabled === true && bCalendarHasPrices === true )
  {
    bIsEnabled = true;
  }

  let sLabel = date.day;

  if ( bIsEnabled !== true )
  {
    // sLabel += '!';
  }

  let iBorderRadius = $state('6px');
  let sDayBorder = $state('3px solid rgb(250 250 250)');

  if ( widgets.bIsThisAWidgetBuildInsteadOfTheShop === true )
  {
    iBorderRadius = '4px';
    sDayBorder = 'none';
  }

</script>

<!--<CalendarPrimitive-->
<Day
  bind:ref
  class={cn(
		// buttonVariants({ variant: "ghost" }),
		// "size-9 p-0 font-normal",
		"ring-offset-background focus-visible:ring-ring inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", // button default, aangepast
		"", // button ghost aangepast - hover:bg-accent hover:text-accent-foreground
		"py-1", // button default size aangepast
		"font-normal",
		"[&[data-today]:not([data-selected])]:bg-accent [&[data-today]:not([data-selected])]:text-accent-foreground",
		// Selected
		"data-[selected]:bg-primary data-[selected]:text-primary-foreground data-[selected]:hover:bg-primary data-[selected]:hover:text-primary-foreground data-[selected]:focus:bg-primary data-[selected]:focus:text-primary-foreground data-[selected]:opacity-100",
		// Disabled
		"data-[disabled]:text-muted-foreground data-[disabled]:opacity-50",
		// Unavailable
		"data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through",
		// Outside months
		"data-[outside-month]:text-muted-foreground [&[data-outside-month][data-selected]]:bg-accent/50 [&[data-outside-month][data-selected]]:text-muted-foreground data-[outside-month]:pointer-events-none data-[outside-month]:opacity-50 [&[data-outside-month][data-selected]]:opacity-30",
		className,
		"hmk-day",
		oCalendarDayConfig.sCustomClass
	)}

  style="width: 100%; border-radius: {iBorderRadius}; border: {sDayBorder};"
  {...restProps}
>
  <div class="day_content">
    {#if oDateConfig?.i?.info}
      <HoverCard.Root>
        <HoverCard.Trigger class="">
          <div class="day_content_date">{sLabel}</div>
          {#if typeof oDateConfig !== "undefined"}
            <div class="day_content_amount">
              {#if oDateConfig.p && bIsEnabled === true}
                <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig.p)}
              {:else if booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY && oDateConfig['p_1'] && bIsEnabled === true}
                <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig['p_1'])}
              {:else if booking.sPreferredPartOfTheDay === ENTRY_DURATION_EVENING && oDateConfig['p_5'] && bIsEnabled === true}
                <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig['p_5'])}
              {:else if widgets.bIsThisAWidgetBuildInsteadOfTheShop === true && oDateConfig['p_1'] && bIsEnabled === true}
                <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig['p_1'])}
              {/if}

              {#if oDateConfig?.i?.info}
                <div class="info-container">
                  <ButtonCalendarInfo/>
                </div>
              {/if}
            </div>
          {:else }
            <div class="day_content_noamount">&nbsp;</div>
          {/if}
        </HoverCard.Trigger>
        <HoverCard.Content class="w-80">
          {oDateConfig?.i?.info}
        </HoverCard.Content>
      </HoverCard.Root>
    {:else}
      <div class="day_content_date">{date.day}</div>
      {#if typeof oDateConfig !== "undefined"}
        <div class="day_content_amount">
          {#if oDateConfig.p && bIsEnabled === true}
            <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig.p)}
          {:else if booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY && oDateConfig['p_1'] && bIsEnabled === true}
            <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig['p_1'])}
          {:else if booking.sPreferredPartOfTheDay === ENTRY_DURATION_EVENING && oDateConfig['p_5'] && bIsEnabled === true}
            <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig['p_5'])}
          {:else if widgets.bIsThisAWidgetBuildInsteadOfTheShop === true && oDateConfig['p_1'] && bIsEnabled === true}
            <span class="euro">&euro;&nbsp;</span>{money_util.centsToString(oDateConfig['p_1'])}
          {/if}
        </div>
      {:else }
        <div class="day_content_noamount">&nbsp;</div>
      {/if}
    {/if}
  </div>
</Day>

<style>
  .info-container {
    position: absolute;
    left: 4px;
    top: 4px;

    @container kalender (min-width: 400px) {
      left: 9px;
      top: 9px;
    }
  }

  /*td[aria-selected="true"] .info-container svg {*/
  /*  color: #fff !important;*/
  /*}*/

  .day_content {
    width: 100%;
    display: flex;
    flex-direction: column;

    .day_content_date {
      text-align: center;
      font-weight: bold;
      font-size: 20px;

      /*padding-top: var(--calendar-day-padding);*/
      /*padding: var(--calendar-day-padding) var(--calendar-day-padding) 0 var(--calendar-day-padding);*/

      @container kalender (min-width: 400px) {
        display: block;
        padding: 9px 0 3px 0;
      }
    }

    .day_content_amount {
      /*display: none;*/
      display: block;
      font-size: 9px;
      /*padding: 0 var(--calendar-day-padding) var(--calendar-day-padding) var(--calendar-day-padding);*/

      @container kalender (min-width: 400px) {
        display: block;
        padding: 3px 0 9px 0;
        font-size: 0.7rem;
      }
    }

    .euro {
      display: none;

      @container kalender (min-width: 400px) {
        /*display: block;*/
        display: none;
      }
    }

    .day_content_noamount {
      height: 12px;
      min-width: 30px;
    }
  }

</style>